import { getAllProducts, updateProduct as update } from '../../api/productFirebase';
import { dynamicSearch } from "../../api/services/productService";

export const Types = {
    LOAD: 'home/LOAD',
    SEARCH: 'home/SEARCH',
    ERROR: 'home/ERROR',
    UPDATE: 'home/UPDATE',
}

const INITIAL_STATE = {
    type: null,
    data: null,
    loading: false,
    error: null,
};

export default function home(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        }
        case Types.LOAD: {
            return { ...state, loading: true };
        }
        case Types.SEARCH: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.UPDATE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        default:
            return state;
    }
}

const errorProduct = (data) => {
    return {
        type: Types.ERROR,
        payload: data
    }
}

const getProductByInput = (data) => {
    return {
        type: Types.SEARCH,
        payload: data
    }
}

const loading = () => {
    return {
        type: Types.LOAD,
    };
}

const updateProduct = (data) => {
    return {
        type: Types.UPDATE,
        payload: data.result
    }
}

export const Creators = {
    getProduct: (name) => {
        return (dispatch) => {
            dispatch(loading());
            getAllProducts((res) => {
                const filteredList = dynamicSearch(res, name);
                let product;

                if (filteredList?.length > 0) {
                    product = filteredList[0];
                }

                dispatch(getProductByInput(product));
            });
        };
    },

    updateProduct: (value, product) => {
        const numberValue = parseInt(value);
        const prod = { ...product, estoque_atual: numberValue }
        
        return (dispatch) => {
            dispatch(loading());
            update(prod.Id, prod)
                .then((res) => {
                    dispatch(updateProduct(res));
                })
                .catch((error) => {
                    dispatch(errorProduct(error));
                });
        }
    },
}
